import React, {Fragment, useState, useEffect} from 'react'
import {Button, Col, Row} from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import UserService from '../../../../../services/user'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../../utils/helpers/FormGenerator'
import MasterServices from '../../../../../services/master'

import {dateFormat} from '../../../../../thesis-and-dissertations/helpers/helper'

type Props = {
  onChange?: (e: any) => void
  toggle: () => void
  getData: any
  editFormValue?: any
  loading?: boolean
}

const FormPersonal: React.FC<Props> = ({toggle, getData, editFormValue, loading}) => {
  const [submit, setSubmit] = useState(false)
  const [formValue, setFormValue] = useState<any>({})

  const [inputs, setInputs] = useState<any>([
    {
      name: 'id_card_number',
      label: 'NIK',
      type: 'number',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      disabled: true
    },
    {
      name: 'tax_id_number',
      label: 'NPWP',
      type: 'number',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'dob',
      label: 'Tanggal Lahir',
      type: 'date',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'gender',
      label: 'Jenis Kelamin',
      type: 'select',
      validation: {},
      col: 6,
      options: [
        {
          name: 'Pria',
          value: '1',
        },
        {
          name: 'Wanita',
          value: '0',
        },
      ],
      additional: '',
      getItemValue: 'name',
      getItemValueId: 'value',
    },
    {
      name: 'phone',
      label: 'No. Handphone & Whatsapp',
      type: 'number',
      validation: {},
      col: 6,
      options: [],
      additional: ''
    },
    {
      name: 'email',
      label: 'Email Terdaftar',
      type: 'email',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      disabled: true
    },
    {
      name: 'alternative_email',
      label: 'Email Alternatif',
      type: 'email',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'is_kerja',
      label: 'Status Pekerjaan',
      type: 'select',
      validation: {},
      col: 6,
      options: [
        {
          name: '-- Pilih Status --',
          value: '',
        },
        {
          name: 'Sudah Bekerja',
          value: '1',
        },
        {
          name: 'Belum Bekerja',
          value: '0',
        },
      ],
      additional: '',
      getItemValue: 'name',
      getItemValueId: 'value',
    },
    {
      name: 'no_rekening',
      label: 'Rekening (Diutamakan Mandiri)',
      type: 'number',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'nama_rekening',
      label: 'Nama Sesuai Rekening',
      type: 'text',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'nama_bank',
      label: 'Nama Bank',
      type: 'select',
      validation: {},
      col: 6,
      options: [
        {
          name: '-- Pilih Bank --',
          value: '',
        },
        {
          name: 'Bank Mandiri',
          value: 'Bank Mandiri',
        },
        {
          name: 'Bank Rakyat Indonesia (BRI)',
          value: 'Bank Rakyat Indonesia (BRI)',
        },
        {
          name: 'Bank Central Asia (BCA)',
          value: 'Bank Central Asia (BCA)',
        },
        {
          name: 'Bank Negara Indonesia (BNI)',
          value: 'Bank Negara Indonesia (BNI)',
        },
        {
          name: 'Bank Tabungan Negara (BTN)',
          value: 'Bank Tabungan Negara (BTN)',
        },
        {
          name: 'Bank CIMB Niaga',
          value: 'Bank CIMB Niaga',
        },
        {
          name: 'Bank Permata',
          value: 'Bank Permata',
        },
        {
          name: 'Bank Danamon',
          value: 'Bank Danamon',
        },
        {
          name: 'Bank Syariah Indonesia (BSI)',
          value: 'Bank Syariah Indonesia (BSI)',
        },
        {
          name: 'Bank OCBC NISP',
          value: 'Bank OCBC NISP',
        },
        {
          name: 'Bank Maybank',
          value: 'Bank Maybank',
        },
        {
          name: 'Bank Panin',
          value: 'Bank Panin',
        },
        {
          name: 'Bank UOB Indonesia',
          value: 'Bank UOB Indonesia',
        },
        {
          name: 'Bank BNI Syariah',
          value: 'Bank BNI Syariah',
        },
        {
          name: 'Bank Mega',
          value: 'Bank Mega',
        },
        {
          name: 'Bank Bukopin',
          value: 'Bank Bukopin',
        },
        {
          name: 'Bank Sinarmas',
          value: 'Bank Sinarmas',
        },
        {
          name: 'Bank DKI',
          value: 'Bank DKI',
        },
        {
          name: 'Bank BJB (Jawa Barat)',
          value: 'Bank BJB (Jawa Barat)',
        },
        {
          name: 'Bank Jatim',
          value: 'Bank Jatim',
        },
        {
          name: 'Bank Lainnya',
          value: 'Bank Lainnya',
        },
      ],
      additional: '',
      getItemValue: 'name',
      getItemValueId: 'value',
    },
  ])

  useEffect(() => {
    setFormValue({
      code_phone: editFormValue?.detail?.user_details_code_phone,
      phone: editFormValue?.detail?.user_details_phone,
      code_wa_phone: editFormValue?.detail?.user_details_wa_code_phone,
      wa_phone: editFormValue?.detail?.user_details_wa_phone,
      fb: editFormValue?.detail?.user_details_fb,
      ig: editFormValue?.detail?.user_details_ig,
      twitter: editFormValue?.detail?.user_details_twitter,
      youtube: editFormValue?.detail?.user_details_youtube,
      description: editFormValue?.detail?.user_details_description,
      gender: editFormValue?.detail?.user_details_gender,
      dob: dateFormat(editFormValue?.detail?.dob),
      email: editFormValue?.email,
      alternative_email: editFormValue?.detail?.alternative_email,
      id_card_number: editFormValue?.detail?.user_details_id_card_number,
      tax_id_number: editFormValue?.detail?.user_details_tax_id_number,
      is_kerja: editFormValue?.detail?.is_kerja,
      no_rekening: editFormValue?.detail?.no_rekening,
      nama_rekening: editFormValue?.detail?.nama_rekening,
      nama_bank: editFormValue?.detail?.nama_bank,
    })
  }, [editFormValue])

  const onChange = (e: any) => {
    const {name, value} = e.target

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleSubmit = async (e: any) => {
    try {
      e?.preventDefault()
      setSubmit(true)
      await UserService.updateProfile(formValue).then(() => {
        toast.success(`Profile Berhasil Diperbarui`)
        toggle()
        getData()
        // Force reload data setelah 500ms untuk memastikan data ter-update
        setTimeout(() => {
          getData()
        }, 500)
      })
    } catch (error) {
    } finally {
      setSubmit(false)
    }
  }

  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>
        <Row>{FormGenerator(inputs, formValue, onChange, onChange, loading)}</Row>
        <Modal.Footer>
          <Button className='btn btn-secondary btn-sm' onClick={toggle} disabled={submit}>
            Batalkan
          </Button>
          <Button className='btn btn-primary btn-sm' type='submit' disabled={submit || loading}>
            {submit ? 'Loading' : 'Simpan'}
          </Button>
        </Modal.Footer>
      </Form>
    </Fragment>
  )
}

export default FormPersonal
